// The last-seen ranges in the unmatched files overview are where these came from. Charts that
// group by time, share, or agent version reuse them so the family stays recognisable; charts of a
// status reach for that status's own chip colour instead.
export const DATE_RANGE_COLORS = ['#87C8E0', '#6FC6B4', '#9CA3AF'];

// A version list runs longer than the three range colours, so each hue gets a second, deeper step
// rather than the palette cycling straight back to the top.
export const DATE_RANGE_RAMP = ['#87C8E0', '#6FC6B4', '#9CA3AF', '#5B9CB8', '#489685', '#6B7280'];

export const rampColor = index => DATE_RANGE_RAMP[index % DATE_RANGE_RAMP.length];
